<div class="inline-number-wrapper">
  @if (!isEditing) {
    <span class="left">
      @if (value === null && !hideButtons) {
        <a (click)="startEdit()" class="add"> Add amount </a>
      }
      @if (value !== null) {
        <span>
          {{ value }}
        </span>
      }
      @if (value !== null && !hideButtons) {
        <button class="edit-button" mat-icon-button (click)="startEdit()">
          <mat-icon class="edit-icon">edit</mat-icon>
        </button>
      }
    </span>
  }
  <div
    class="editing"
    [ngClass]="{
      hidden: !isEditing,
    }"
  >
    <form>
      <mat-form-field appearance="outline">
        <input
          matInput
          class="editable"
          [mask]="'separator.' + decimals"
          [thousandSeparator]="disableThousandsSeparator ? '' : ','"
          separatorLimit="99999999"
          name="value"
          [placeholder]="placeholder"
          #editInput
          (keydown.enter)="!valueControl.invalid ? confirmEdit() : preventKeydown($event)"
          (keydown.escape)="cancelEdit()"
          [formControl]="valueControl"
        />
      </mat-form-field>

      @if (valueControl.errors) {
        @for (error of valueControl.errors | keyvalue; track error) {
          <mat-error class="resolution-number-error"
            ><mat-icon>warning</mat-icon>
            @if (error.key === 'nonZero') {
              Value cannot be 0
            }
            @if (error.key === 'required') {
              Value cannot be Empty
            }
            @if (!['nonZero', 'required'].includes(error.key)) {
              {{ error.value }}
            }
          </mat-error>
        }
      }
    </form>
    @if (!hideButtons) {
      <div class="button-container">
        <button mat-button (click)="cancelEdit()">CANCEL</button>
        <button
          mat-button
          [class.disabled]="valueControl.invalid"
          [class.save]="!valueControl.invalid"
          (click)="confirmEdit()"
          [disabled]="valueControl.invalid"
        >
          SAVE
        </button>
      </div>
    }
  </div>
</div>
